import React, { useContext, useState } from "react";
import { gql } from "@apollo/client";
import { Alert, Box, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import EnhancedTable from "@vocollege/components/dist/EnhancedTable";
import Layout from "containers/Layout/Layout";
import { VoAppContext } from "services/GlobalState";
import VoAuth from "@vocollege/app/dist/modules/VoAuth";

export const RETENTION_ACCOUNTS = gql`
  query RetentionAccounts($page: Int, $limit: Int, $search: String, $filters: [RetentionTableFilter!], $orderBy: [RetentionTableOrder!]) {
    retentionAccounts(tablePage: $page, limit: $limit, search: $search, filters: $filters, orderBy: $orderBy) {
      enabled paginatorInfo { total }
      data { id name email status reason lastLoginAt eligibleAt }
    }
  }
`;
// EnhancedTable initializes a mutation even for read-only lists. This operation cannot delete data.
const READ_ONLY_OPERATION = gql`mutation RetentionReadOnly { __typename }`;
const statuses: Record<string, string> = { eligible: "Alla kommande gallringar (16+ månader)", candidate: "Klara för gallring", upcoming: "Gallras inom två månader", blocked: "Undantagna konton", unknown: "Saknar tidsunderlag", all: "Alla i underlaget" };
const reasons: Record<string, string> = { excluded: "Undantagen från automatisk gallring", licensee_contact: "Kontaktperson för Validig-licenstagare", invalid_settings: "Inställningar behöver kontrolleras", missing_activity_baseline: "Saknar inloggnings- och skapandedatum" };
const date = (value: string | null) => value ? new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Stockholm", dateStyle: "short" }).format(new Date(value)) : "—";
export default function Retention() {
  const { state } = useContext(VoAppContext);
  const [enabled, setEnabled] = useState<boolean>();
  const allowed = !state.group && VoAuth.ability.can("delete", "Users") && VoAuth.ability.can("list", "Users");
  return <Layout><Box p={3}><Stack spacing={2}>
    {!allowed ? <Alert severity="warning">Listan är endast tillgänglig för central administration med behörighet att lista och radera användare.</Alert> : <>
      <Alert severity="info">Underlag för 18-månadersgallring och månadsmejlet. Senaste inloggning används, eller skapandedatum om kontot aldrig har loggat in. Undantagna konton och kontaktpersoner för Validig-licenstagare gallras inte. Listan visar konton med minst 16 månaders inaktivitet, utan övre gräns. Avtalsgallring hanteras på respektive grupp.</Alert>
      {enabled === false && <Alert severity="warning">Automatisk gallring är avstängd i denna miljö.</Alert>}
      <EnhancedTable
        title="Gallring"
        operations={{ category: "retentionAccounts", get: RETENTION_ACCOUNTS, delete: READ_ONLY_OPERATION }}
        enableSearch
        actionButtons={[]}
        orderBy="ID" order="ASC"
        onDataChange={data => setEnabled(data.retentionAccounts.enabled)}
        filters={[{ name: "status", label: "Gallringsstatus", default: ["eligible"], values: Object.entries(statuses).map(([value, label]) => ({ value, label })) }]}
        columns={[
          { title: "ID", field: "id" },
          { title: "Konto", field: "name", disableSort: true, render: (row: any) => <Link to={`/users/${row.id}`}>{row.name || "Namnlöst konto"}</Link> },
          { title: "E-post", field: "email", disableSort: true },
          { title: "Senaste inloggning / skapad", field: "lastLoginAt", render: (row: any) => date(row.lastLoginAt) },
          { title: "18-månadersdatum", field: "eligibleAt", render: (row: any) => date(row.eligibleAt) },
          { title: "Status / undantag", field: "status", disableSort: true, render: (row: any) => row.reason ? reasons[row.reason] || row.reason : statuses[row.status] },
        ]}
      />
    </>}
  </Stack></Box></Layout>;
}
